import React, { useState, useEffect } from 'react';
import { Grid } from "@mui/material";
import KeyMetricsCard from "./key-metrics-card.component";
import useAnalytics from "./../../hooks/useAnalytics";

const KeyMetricsStats = () => {

    const {total_verification_group_by_status, getTotalVerificationGroupByStatus, total_authentication, getTotalAuthentication} = useAnalytics();
    
    const [successfulCount, setSuccessfulCount] = useState(0);
    const [suspiciousCount, setSuspiciousCount] = useState(0);
    const [invalidCount, setInvalidCount] = useState(0);
    const [expiredCount, setExpiredCount] = useState(0);


    useEffect(() => {
        getTotalVerificationGroupByStatus();
        getTotalAuthentication();
    }, [])

    useEffect(() => {
        if (total_verification_group_by_status?.length) {
            const successful = total_verification_group_by_status?.find(
                (item) => item.status === "Successful"
            )?.count || 0;

            const suspicious = total_verification_group_by_status?.find(
                (item) => item.status === "Suspicious"
            )?.count || 0;

            const invalid = total_verification_group_by_status?.find(
                (item) => item.status === "Invalid"
            )?.count || 0;

            const expired = total_verification_group_by_status?.find(
                (item) => item.status === "Expired"
            )?.count || 0;

            setSuccessfulCount(successful);
            setSuspiciousCount(suspicious);
            setInvalidCount(invalid);
            setExpiredCount(expired);
        }
    },  [total_verification_group_by_status]);


    return (
        <Grid container spacing={6}>
            <Grid item xs={6} sm={6} md={6} lg={2.4} xl={2.4}>
                <KeyMetricsCard 
                    bgcolor="#e3efef" 
                    bordercolor="#aad7c4"
                    titlecolor="#3fbf7e" 
                    title={successfulCount?.toLocaleString()}
                    description="Total Successful Verifications" 
                />
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={2.4} xl={2.4}>
                <KeyMetricsCard 
                    bgcolor="#f6efe5" 
                    bordercolor="#f3d397" 
                    title={suspiciousCount?.toLocaleString()} 
                    titlecolor="#fda501" 
                    description="Total Suspicious Verifications" 
                />
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={2.4} xl={2.4}>
                <KeyMetricsCard 
                    bgcolor="#f4e4e5" 
                    bordercolor="#e8c5c2" 
                    title={invalidCount?.toLocaleString()} 
                    titlecolor="#e67260" 
                    description="Total Invalid Verifications" 
                />
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={2.4} xl={2.4}>
                <KeyMetricsCard 
                    bgcolor="#e0e0e0" 
                    bordercolor="#b0b0b0" 
                    title={expiredCount?.toLocaleString()} 
                    titlecolor="#616161" 
                    description="Total Expired Verifications" 
                />
            </Grid>

            <Grid item xs={6} sm={6} md={6} lg={2.4} xl={2.4}>
                <KeyMetricsCard 
                    bgcolor="#e6e5f7" 
                    bordercolor="#abaadf" 
                    title={total_authentication?.toLocaleString() || 0}
                    titlecolor="#5656d3" 
                    description="Total Authentications" 
                />
            </Grid>
        </Grid>
    )
    
}

export default KeyMetricsStats;